import Header from './Components/Header';
import { Route, Switch } from "react-router-dom";
import {useState, useEffect} from 'react';
import Home from './Pages/Home';
import Movies from './Pages/Movies'
import Series from './Pages/Series';
import Books from './Pages/Books';
import Saved from './Pages/Saved';
import Done from './Pages/Done';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  let [online, isOnline] = useState(navigator.onLine);
  const notifyOffline = () => toast.warn("You're currently working in offline mode.", {
    draggable: false,
    closeOnClick: false,
    closeButton: false,
    autoClose: 5000,
    theme: "light",
    bodyClassName: "grow-font-size"
  })
  const notifyOnline = () => toast.success("You're back online!", {
    draggable: false,
    closeOnClick: false,
    closeButton: false,
    autoClose: 5000,
    theme: "light",
    bodyClassName: "grow-font-size"
  })

  const setOnline = () => {
    console.log("We are online.");
    isOnline(true);
  }

  const setOffline = () => {
    console.log("We are offline.");
    isOnline(false);
  }

  useEffect(() => {
    window.addEventListener('offline', setOffline);
    window.addEventListener('offline', notifyOffline);
    window.addEventListener('online', setOnline);
    window.addEventListener('online', notifyOnline);

    return () => {
      window.removeEventListener('offline', setOffline);
      window.removeEventListener('offline', notifyOffline);
      window.removeEventListener('online', setOnline);
      window.removeEventListener('online', notifyOnline);
    }
  }, []);

  return (
      <div>
        <Header />
      <Switch> 
        <Route exact path='/' component={Home} />
        <Route exact path='/movies' component={Movies} />
        <Route exact path="/series" component={Series} />
        <Route exact path="/books" component={Books} />
        <Route exact path="/saved" component={Saved} />
        <Route exact path="/done" component={Done} />
      </Switch>
      <ToastContainer
        position="bottom-center"
        newestOnTop={true}
        />
      </div>
  );
}

export default App;
